import { render, staticRenderFns } from "./SiteMap.vue?vue&type=template&id=b8a48e2a&"
import script from "./SiteMap.vue?vue&type=script&lang=js&"
export * from "./SiteMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports